import React from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { useRootStore } from "../../../../store/contexts";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { FormSaveFooter } from "../../../../common/controls/forms/FormSaveFooter";

import FormExtras from "../../../../common/components/formExtras";
import { DocumentGenerationParamsCreateStore } from "../../store";
import { InputDate } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type DocumentGenerationParamsCreateFormProps = {
  onSave?: () => void;
  onCancel?: () => void;
  /** Mientras se guarda, Guardar queda deshabilitado. */
  saving?: boolean;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
  contractEffectiveDateSelectedValue?: { displayId: string; id: string } | null;
  onContractEffectiveDateChange?: (value: string | null) => void;
  contractEffectiveDate: string | null;
  contractEffectiveDateError?: string;
  contractEndDateSelectedValue?: { displayId: string; id: string } | null;
  onContractEndDateChange?: (value: string | null) => void;
  contractEndDate: string | null;
  contractEndDateError?: string;
  documentGenerationParamsCreateStore: DocumentGenerationParamsCreateStore;
};

export const DocumentGenerationParamsCreateForm: React.FC<DocumentGenerationParamsCreateFormProps> =
  observer(
    ({
      onSave = () => {},
      onCancel = () => {},
      saving = false,
      showToolbox = true,
      showSaveFooter,
      contractEffectiveDate = null,
      contractEffectiveDateError,
      onContractEffectiveDateChange = () => {},
      contractEndDate = null,
      contractEndDateError,
      onContractEndDateChange = () => {},
      documentGenerationParamsCreateStore,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              saveAndCloseLabel={langStore.saveEntity}
              closeLabel={langStore.cancelNewEntity}
              saveForm={() => onSave()}
              saveDisabled={saving}
              closeForm={() => onCancel()}
            />
          )}
          <Box>
            <FormExtras
              entity="DocumentGenerationParams"
              mode="create"
              values={{}}
              options={{}}
              onPatch={(campo: string, valor: any) => {
                switch (campo) {
                  case "contractEffectiveDate":
                    onContractEffectiveDateChange?.(valor);
                    break;
                  case "contractEndDate":
                    onContractEndDateChange?.(valor);
                    break;
                }
              }}
            />
            <GroupContainer
              id="null"
              errorText={documentGenerationParamsCreateStore.getCardErrors(
                "null"
              )}
              title={langStore.groupDocumentGenerationParamsLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <InputDate
                  autoFocus
                  value={contractEffectiveDate}
                  error={Boolean(contractEffectiveDateError)}
                  warning={
                    !contractEffectiveDateError &&
                    Boolean(
                      documentGenerationParamsCreateStore.warnings[
                        "contractEffectiveDate"
                      ]
                    )
                  }
                  helperText={
                    contractEffectiveDateError ||
                    documentGenerationParamsCreateStore.warnings[
                      "contractEffectiveDate"
                    ]?.message
                  }
                  label={
                    langStore.DocumentGenerationParamsContractEffectiveDateLabel
                  }
                  description={
                    langStore.DocumentGenerationParamsContractEffectiveDateDescription
                  }
                  onChange={(value: string | null | null) =>
                    onContractEffectiveDateChange(value)
                  }
                />
                <InputDate
                  value={contractEndDate}
                  error={Boolean(contractEndDateError)}
                  warning={
                    !contractEndDateError &&
                    Boolean(
                      documentGenerationParamsCreateStore.warnings[
                        "contractEndDate"
                      ]
                    )
                  }
                  helperText={
                    contractEndDateError ||
                    documentGenerationParamsCreateStore.warnings[
                      "contractEndDate"
                    ]?.message
                  }
                  label={langStore.DocumentGenerationParamsContractEndDateLabel}
                  nullText={langStore.optionalFieldHint}
                  description={
                    langStore.DocumentGenerationParamsContractEndDateDescription
                  }
                  onChange={(value: string | null | null) =>
                    onContractEndDateChange(value)
                  }
                />
              </FormControl>
            </GroupContainer>
          </Box>
          {(showSaveFooter ?? !showToolbox) && (
            <FormSaveFooter
              onSave={() => onSave()}
              label={langStore.saveEntity}
              disabled={saving}
            />
          )}
        </Grid>
      );
    }
  );
